// src/services/authService.js

const BASE_URL = window.location.origin;

// ─── Env Validation ──────────────────────────────────────────────
const required = (key) => {
  const val = process.env[key];
  if (!val) throw new Error(`[authService] Eksik env: ${key}`);
  return val;
};

// ─── CSRF State ───────────────────────────────────────────────────
const STATE_KEY = 'sso_oauth_state';

const generateState = () => {
  const state = crypto.randomUUID();
  sessionStorage.setItem(STATE_KEY, state);
  return state;
};

const validateState = (incoming) => {
  const stored = sessionStorage.getItem(STATE_KEY);
  sessionStorage.removeItem(STATE_KEY);
  if (!stored || stored !== incoming) {
    throw new Error('Geçersiz OAuth state — olası CSRF saldırısı');
  }
};

// ─── Google SSO ───────────────────────────────────────────────────
export const redirectToGoogleSSO = () => {
  const ssoUrl = required('REACT_APP_SSO_API_URL');
  const state  = generateState();

  const params = new URLSearchParams({
    client_id:     'api-gateway-client',
    response_type: 'code',
    scope:         'openid',
    redirect_uri:  `${BASE_URL}/portal/login`,
    kc_idp_hint:   'google',
    state,
  });

  window.location.href = `${ssoUrl}/protocol/openid-connect/auth?${params}`;
};

// ─── Token Exchange ───────────────────────────────────────────────
export const exchangeCodeForToken = async (code, state) => {
  // State yoksa (Keycloak bazen göndermez) sadece uyar, bloklama
  if (state) validateState(state);

  const apiUrl = required('REACT_APP_API_URL');

  const response = await fetch(
    `${apiUrl}/access/login/token-with-authorization-code`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code,
        redirect_uri: `${BASE_URL}/portal/login`,
      }),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};

// ─── Session ──────────────────────────────────────────────────────
export const saveSession = (payload) => {
  sessionStorage.setItem('currentSession', JSON.stringify(payload));
};

export const clearSession = () => {
  sessionStorage.removeItem('currentSession');
};